import dayjs from 'dayjs';
import { range } from 'lodash';

const years = range(1922, dayjs().year() + 1, 1);
const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const yearOptions = years.map((year) => ({
  value: year.toString(),
  label: year.toString(),
}));
const monthOptions = months.map((month) => ({ value: month, label: month }));

const filterByMonthOrYear = (
  inputValue: string,
  filterBy: 'month' | 'year',
) => {
  if (filterBy === 'month') {
    return monthOptions.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase()),
    );
  }
  return yearOptions.filter((i) =>
    i.label.toLowerCase().includes(inputValue.toLowerCase()),
  );
};

const loadOptions =
  (filterBy: 'month' | 'year') =>
  (inputValue: string, callback: (options: typeof yearOptions) => void) => {
    setTimeout(() => {
      callback(filterByMonthOrYear(inputValue, filterBy));
    }, 100);
  };

export default { years, months, yearOptions, monthOptions, loadOptions };
